import { 
  StoreDisplayGroupPlanogramApply, 
  TeamType, 
  ApplyStatus 
} from '../types/storeDisplayGroupPlanogramApply';

// Mock data for Store Display Group Planogram Apply
export const mockStoreDisplayGroupPlanogramApplies: StoreDisplayGroupPlanogramApply[] = [
  {
    id: 1,
    source: 'benchmark',
    applyNo: 'SDGPA202501001',
    planogramCode: 'PLG001',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST001',
    storeName: '北京朝阳店',
    storeGroupCode: 'SG001',
    storeGroupName: '北京地区门店组',
    displayGroupCode: 'DG001',
    displayGroupName: '饮料陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user001',
    applyPersonName: '张三',
    applyTime: '2025-01-15 10:30:00',
    applyReason: '需要更新春节促销商品陈列，调整饮料区域布局以提升销售效果',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-01-25',
    actualEndDate: null,
    creatorAccount: 'user001',
    creatorName: '张三',
    gmtCreate: '2025-01-15 10:30:00',
    modifierAccount: 'user001',
    modifierName: '张三',
    gmtModified: '2025-01-15 10:30:00',
    deleted: 0
  },
  {
    id: 2,
    source: 'algorithm',
    applyNo: 'SDGPA202501002',
    planogramCode: 'PLG002',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST002',
    storeName: '上海浦东店',
    storeGroupCode: 'SG002',
    storeGroupName: '上海地区门店组',
    displayGroupCode: 'DG002',
    displayGroupName: '零食陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user002',
    applyPersonName: '李四',
    applyTime: '2025-01-14 14:20:00',
    applyReason: '新品上架需要调整零食货架陈列图，优化商品展示效果',
    auditPerson: 'manager001',
    auditPersonName: '王经理',
    auditTime: '2025-01-15 09:15:00',
    auditRemark: '申请理由充分，批准执行',
    expectedEndDate: '2025-01-20',
    actualEndDate: '2025-01-19',
    creatorAccount: 'user002',
    creatorName: '李四',
    gmtCreate: '2025-01-14 14:20:00',
    modifierAccount: 'manager001',
    modifierName: '王经理',
    gmtModified: '2025-01-15 09:15:00',
    deleted: 0
  },
  {
    id: 3,
    source: 'benchmark',
    applyNo: 'SDGPA202501003',
    planogramCode: 'PLG003',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST003',
    storeName: '深圳南山店',
    storeGroupCode: 'SG003',
    storeGroupName: '深圳地区门店组',
    displayGroupCode: 'DG003',
    displayGroupName: '日用品陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.REJECTED,
    applyPerson: 'user003',
    applyPersonName: '赵五',
    applyTime: '2025-01-13 16:45:00',
    applyReason: '临时调整陈列方案',
    auditPerson: 'manager002',
    auditPersonName: '刘经理',
    auditTime: '2025-01-14 11:30:00',
    auditRemark: '申请理由不够详细，请补充具体调整原因和预期效果',
    expectedEndDate: '2025-01-18',
    actualEndDate: null,
    creatorAccount: 'user003',
    creatorName: '赵五',
    gmtCreate: '2025-01-13 16:45:00',
    modifierAccount: 'manager002',
    modifierName: '刘经理',
    gmtModified: '2025-01-14 11:30:00',
    deleted: 0
  },
  {
    id: 4,
    source: 'algorithm',
    applyNo: 'SDGPA202501004',
    planogramCode: 'PLG004',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST001',
    storeName: '北京朝阳店',
    storeGroupCode: 'SG001',
    storeGroupName: '北京地区门店组',
    displayGroupCode: 'DG004',
    displayGroupName: '生鲜陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user004',
    applyPersonName: '钱六',
    applyTime: '2025-01-16 08:30:00',
    applyReason: '生鲜区域重新规划，需要更新陈列图以配合新的冷柜布局',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-01-22',
    actualEndDate: null,
    creatorAccount: 'user004',
    creatorName: '钱六',
    gmtCreate: '2025-01-16 08:30:00',
    modifierAccount: 'user004',
    modifierName: '钱六',
    gmtModified: '2025-01-16 08:30:00',
    deleted: 0
  },
  {
    id: 5,
    source: 'benchmark',
    applyNo: 'SDGPA202501005',
    planogramCode: 'PLG005',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST004',
    storeName: '广州天河店',
    storeGroupCode: 'SG004',
    storeGroupName: '广州地区门店组',
    displayGroupCode: 'DG005',
    displayGroupName: '服装陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user005',
    applyPersonName: '孙七',
    applyTime: '2025-01-12 13:20:00',
    applyReason: '春装上新，需要调整服装区域陈列以突出新款商品',
    auditPerson: 'manager003',
    auditPersonName: '陈经理',
    auditTime: '2025-01-13 10:00:00',
    auditRemark: '新品陈列方案合理，同意实施',
    expectedEndDate: '2025-01-17',
    actualEndDate: '2025-01-16',
    creatorAccount: 'user005',
    creatorName: '孙七',
    gmtCreate: '2025-01-12 13:20:00',
    modifierAccount: 'manager003',
    modifierName: '陈经理',
    gmtModified: '2025-01-13 10:00:00',
    deleted: 0
  },
  {
    id: 6,
    source: 'algorithm',
    applyNo: 'SDGPA202501006',
    planogramCode: 'PLG006',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST005',
    storeName: '成都锦江店',
    storeGroupCode: 'SG005',
    storeGroupName: '成都地区门店组',
    displayGroupCode: 'DG006',
    displayGroupName: '家电陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user006',
    applyPersonName: '周八',
    applyTime: '2025-01-17 11:00:00',
    applyReason: '家电促销活动需要重新调整陈列方案，突出主推产品',
    auditPerson: 'manager004',
    auditPersonName: '吴经理',
    auditTime: '2025-01-17 15:30:00',
    auditRemark: '促销方案合理，按计划执行',
    expectedEndDate: '2025-01-23',
    actualEndDate: '2025-01-22',
    creatorAccount: 'user006',
    creatorName: '周八',
    gmtCreate: '2025-01-17 11:00:00',
    modifierAccount: 'manager004',
    modifierName: '吴经理',
    gmtModified: '2025-01-17 15:30:00',
    deleted: 0
  },
  {
    id: 7,
    source: 'benchmark',
    applyNo: 'SDGPA202501007',
    planogramCode: 'PLG007',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST006',
    storeName: '杭州西湖店',
    storeGroupCode: 'SG006',
    storeGroupName: '杭州地区门店组',
    displayGroupCode: 'DG007',
    displayGroupName: '图书陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user007',
    applyPersonName: '吴九',
    applyTime: '2025-01-18 09:45:00',
    applyReason: '新书上架，需要调整图书区域陈列以增加新书曝光度',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-01-28',
    actualEndDate: null,
    creatorAccount: 'user007',
    creatorName: '吴九',
    gmtCreate: '2025-01-18 09:45:00',
    modifierAccount: 'user007',
    modifierName: '吴九',
    gmtModified: '2025-01-18 09:45:00',
    deleted: 0
  },
  {
    id: 8,
    source: 'algorithm',
    applyNo: 'SDGPA202501008',
    planogramCode: 'PLG008',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST007',
    storeName: '南京鼓楼店',
    storeGroupCode: 'SG007',
    storeGroupName: '南京地区门店组',
    displayGroupCode: 'DG008',
    displayGroupName: '化妆品陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.REJECTED,
    applyPerson: 'user008',
    applyPersonName: '郑十',
    applyTime: '2025-01-11 16:20:00',
    applyReason: '季节性调整化妆品陈列',
    auditPerson: 'manager005',
    auditPersonName: '林经理',
    auditTime: '2025-01-12 10:45:00',
    auditRemark: '申请资料不完整，需要提供详细的调整方案',
    expectedEndDate: '2025-01-21',
    actualEndDate: null,
    creatorAccount: 'user008',
    creatorName: '郑十',
    gmtCreate: '2025-01-11 16:20:00',
    modifierAccount: 'manager005',
    modifierName: '林经理',
    gmtModified: '2025-01-12 10:45:00',
    deleted: 0
  },
  {
    id: 9,
    source: 'benchmark',
    applyNo: 'SDGPA202501009',
    planogramCode: 'PLG009',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST008',
    storeName: '武汉江汉店',
    storeGroupCode: 'SG008',
    storeGroupName: '武汉地区门店组',
    displayGroupCode: 'DG009',
    displayGroupName: '母婴陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user009',
    applyPersonName: '王十一',
    applyTime: '2025-01-19 14:15:00',
    applyReason: '母婴产品新品上架，需要优化陈列方案提升销售转化',
    auditPerson: 'manager006',
    auditPersonName: '赵经理',
    auditTime: '2025-01-19 17:30:00',
    auditRemark: '新品陈列方案设计合理，同意实施',
    expectedEndDate: '2025-01-26',
    actualEndDate: null,
    creatorAccount: 'user009',
    creatorName: '王十一',
    gmtCreate: '2025-01-19 14:15:00',
    modifierAccount: 'manager006',
    modifierName: '赵经理',
    gmtModified: '2025-01-19 17:30:00',
    deleted: 0
  },
  {
    id: 10,
    source: 'algorithm',
    applyNo: 'SDGPA202501010',
    planogramCode: 'PLG010',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST009',
    storeName: '西安雁塔店',
    storeGroupCode: 'SG009',
    storeGroupName: '西安地区门店组',
    displayGroupCode: 'DG010',
    displayGroupName: '运动用品陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user010',
    applyPersonName: '李十二',
    applyTime: '2025-01-20 10:00:00',
    applyReason: '运动用品春季促销活动准备，需要调整陈列突出促销商品',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-01-30',
    actualEndDate: null,
    creatorAccount: 'user010',
    creatorName: '李十二',
    gmtCreate: '2025-01-20 10:00:00',
    modifierAccount: 'user010',
    modifierName: '李十二',
    gmtModified: '2025-01-20 10:00:00',
    deleted: 0
  },
  {
    id: 11,
    source: 'benchmark',
    applyNo: 'SDGPA202501011',
    planogramCode: 'PLG011',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST010',
    storeName: '重庆渝中店',
    storeGroupCode: 'SG010',
    storeGroupName: '重庆地区门店组',
    displayGroupCode: 'DG011',
    displayGroupName: '数码产品陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user011',
    applyPersonName: '陈十三',
    applyTime: '2025-01-21 15:30:00',
    applyReason: '数码产品新品上架，需要调整陈列方案以突出新品特色',
    auditPerson: 'manager007',
    auditPersonName: '郭经理',
    auditTime: '2025-01-22 09:00:00',
    auditRemark: '新品陈列方案合理，同意实施',
    expectedEndDate: '2025-01-28',
    actualEndDate: '2025-01-27',
    creatorAccount: 'user011',
    creatorName: '陈十三',
    gmtCreate: '2025-01-21 15:30:00',
    modifierAccount: 'manager007',
    modifierName: '郭经理',
    gmtModified: '2025-01-22 09:00:00',
    deleted: 0
  },
  {
    id: 12,
    source: 'algorithm',
    applyNo: 'SDGPA202501012',
    planogramCode: 'PLG012',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST011',
    storeName: '天津河东店',
    storeGroupCode: 'SG011',
    storeGroupName: '天津地区门店组',
    displayGroupCode: 'DG012',
    displayGroupName: '健康保健陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user012',
    applyPersonName: '孙十四',
    applyTime: '2025-01-22 11:20:00',
    applyReason: '健康保健产品季节性调整，需要优化陈列布局',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-01-30',
    actualEndDate: null,
    creatorAccount: 'user012',
    creatorName: '孙十四',
    gmtCreate: '2025-01-22 11:20:00',
    modifierAccount: 'user012',
    modifierName: '孙十四',
    gmtModified: '2025-01-22 11:20:00',
    deleted: 0
  },
  {
    id: 13,
    source: 'benchmark',
    applyNo: 'SDGPA202501013',
    planogramCode: 'PLG013',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST012',
    storeName: '大连中山店',
    storeGroupCode: 'SG012',
    storeGroupName: '辽宁地区门店组',
    displayGroupCode: 'DG013',
    displayGroupName: '酒类陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.REJECTED,
    applyPerson: 'user013',
    applyPersonName: '吴十五',
    applyTime: '2025-01-19 13:40:00',
    applyReason: '节日促销酒类陈列调整',
    auditPerson: 'manager008',
    auditPersonName: '朱经理',
    auditTime: '2025-01-20 16:15:00',
    auditRemark: '酒类陈列需要符合相关法规要求，请重新提交方案',
    expectedEndDate: '2025-01-25',
    actualEndDate: null,
    creatorAccount: 'user013',
    creatorName: '吴十五',
    gmtCreate: '2025-01-19 13:40:00',
    modifierAccount: 'manager008',
    modifierName: '朱经理',
    gmtModified: '2025-01-20 16:15:00',
    deleted: 0
  },
  {
    id: 14,
    source: 'algorithm',
    applyNo: 'SDGPA202501014',
    planogramCode: 'PLG014',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST002',
    storeName: '上海浦东店',
    storeGroupCode: 'SG002',
    storeGroupName: '上海地区门店组',
    displayGroupCode: 'DG014',
    displayGroupName: '文具办公陈列分组',
    teamType: TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.APPROVED,
    applyPerson: 'user014',
    applyPersonName: '郑十六',
    applyTime: '2025-01-23 10:15:00',
    applyReason: '开学季文具用品需求增加，需要调整陈列以提高曝光度',
    auditPerson: 'manager009',
    auditPersonName: '徐经理',
    auditTime: '2025-01-23 14:00:00',
    auditRemark: '学生用品季节性调整合理，批准执行',
    expectedEndDate: '2025-02-01',
    actualEndDate: null,
    creatorAccount: 'user014',
    creatorName: '郑十六',
    gmtCreate: '2025-01-23 10:15:00',
    modifierAccount: 'manager009',
    modifierName: '徐经理',
    gmtModified: '2025-01-23 14:00:00',
    deleted: 0
  },
  {
    id: 15,
    source: 'benchmark',
    applyNo: 'SDGPA202501015',
    planogramCode: 'PLG015',
    planogramImageUrl: 'https://imgs.699pic.com/images/600/373/015.jpg!list1x.v2',
    storeCode: 'ST004',
    storeName: '广州天河店',
    storeGroupCode: 'SG004',
    storeGroupName: '广州地区门店组',
    displayGroupCode: 'DG015',
    displayGroupName: '玉器工艺品陈列分组',
    teamType: TeamType.PLANOGRAM,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: 'user015',
    applyPersonName: '李十七',
    applyTime: '2025-01-24 16:50:00',
    applyReason: '传统工艺品新品上架，需要优化陈列方案以突出文化特色',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: '2025-02-03',
    actualEndDate: null,
    creatorAccount: 'user015',
    creatorName: '李十七',
    gmtCreate: '2025-01-24 16:50:00',
    modifierAccount: 'user015',
    modifierName: '李十七',
    gmtModified: '2025-01-24 16:50:00',
    deleted: 0
  }
];

// Mock store codes for dropdown options
export const mockStoreCodes = [
  { code: 'ST001', name: '北京朝阳店' },
  { code: 'ST002', name: '上海浦东店' },
  { code: 'ST003', name: '深圳南山店' },
  { code: 'ST004', name: '广州天河店' },
  { code: 'ST005', name: '成都锦江店' },
  { code: 'ST006', name: '杭州西湖店' },
  { code: 'ST007', name: '南京鼓楼店' },
  { code: 'ST008', name: '武汉江汉店' },
  { code: 'ST009', name: '西安雁塔店' },
  { code: 'ST010', name: '重庆渝中店' },
  { code: 'ST011', name: '天津河东店' },
  { code: 'ST012', name: '大连中山店' }
];

// Mock planogram codes for dropdown options
export const mockPlanogramCodes = [
  { code: 'PLG001', name: '饮料区域陈列图' },
  { code: 'PLG002', name: '零食区域陈列图' },
  { code: 'PLG003', name: '日用品区域陈列图' },
  { code: 'PLG004', name: '生鲜区域陈列图' },
  { code: 'PLG005', name: '服装区域陈列图' },
  { code: 'PLG006', name: '家电区域陈列图' },
  { code: 'PLG007', name: '图书区域陈列图' },
  { code: 'PLG008', name: '化妆品区域陈列图' },
  { code: 'PLG009', name: '母婴区域陈列图' },
  { code: 'PLG010', name: '运动用品区域陈列图' },
  { code: 'PLG011', name: '数码产品区域陈列图' },
  { code: 'PLG012', name: '健康保健区域陈列图' },
  { code: 'PLG013', name: '酒类区域陈列图' },
  { code: 'PLG014', name: '文具办公区域陈列图' },
  { code: 'PLG015', name: '玉器工艺品区域陈列图' }
];

// Mock display group codes for dropdown options
export const mockDisplayGroupCodes = [
  { code: 'DG001', name: '饮料陈列分组' },
  { code: 'DG002', name: '零食陈列分组' },
  { code: 'DG003', name: '日用品陈列分组' },
  { code: 'DG004', name: '生鲜陈列分组' },
  { code: 'DG005', name: '服装陈列分组' },
  { code: 'DG006', name: '家电陈列分组' },
  { code: 'DG007', name: '图书陈列分组' },
  { code: 'DG008', name: '化妆品陈列分组' },
  { code: 'DG009', name: '母婴陈列分组' },
  { code: 'DG010', name: '运动用品陈列分组' },
  { code: 'DG011', name: '数码产品陈列分组' },
  { code: 'DG012', name: '健康保健陈列分组' },
  { code: 'DG013', name: '酒类陈列分组' },
  { code: 'DG014', name: '文具办公陈列分组' },
  { code: 'DG015', name: '玉器工艺品陈列分组' }
];

/**
 * Get apply by ID
 * @param id Apply ID
 * @returns Apply or null if not found
 */
export const getApplyById = (id: number): StoreDisplayGroupPlanogramApply | null => {
  return mockStoreDisplayGroupPlanogramApplies.find(apply => apply.id === id) || null;
};

/**
 * Get apply by apply number
 * @param applyNo Apply number
 * @returns Apply or null if not found
 */
export const getApplyByApplyNo = (applyNo: string): StoreDisplayGroupPlanogramApply | null => {
  return mockStoreDisplayGroupPlanogramApplies.find(apply => apply.applyNo === applyNo) || null;
};

/**
 * Get store code options for dropdown
 * @returns Array of store code options
 */
export const getStoreCodeOptions = () => {
  return mockStoreCodes;
};

/**
 * Get planogram code options for dropdown
 * @returns Array of planogram code options
 */
export const getPlanogramCodeOptions = () => {
  return mockPlanogramCodes;
};

/**
 * Get display group code options for dropdown
 * @returns Array of display group code options
 */
export const getDisplayGroupCodeOptions = () => {
  return mockDisplayGroupCodes;
};

/**
 * Generate next apply number
 * @returns Next apply number in sequence
 */
export const generateNextApplyNo = (): string => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  
  // Find the highest existing number for today
  const today = `${year}${month}${day}`;
  const todayApplies = mockStoreDisplayGroupPlanogramApplies.filter(apply => 
    apply.applyNo.includes(today)
  );
  
  const maxNumber = todayApplies.reduce((max, apply) => {
    const match = apply.applyNo.match(/(\d{3})$/);
    if (match) {
      const num = parseInt(match[1], 10);
      return Math.max(max, num);
    }
    return max;
  }, 0);
  
  const nextNumber = String(maxNumber + 1).padStart(3, '0');
  return `SDGPA${year}${month}${nextNumber}`;
};

/**
 * Simulate creating a new apply
 * @param apply Apply data to create
 * @returns Created apply with generated ID and timestamps
 */
export const createMockApply = (apply: Partial<StoreDisplayGroupPlanogramApply>): StoreDisplayGroupPlanogramApply => {
  const maxId = Math.max(...mockStoreDisplayGroupPlanogramApplies.map(a => a.id), 0);
  const now = new Date().toISOString().replace('T', ' ').substring(0, 19);
  
  const newApply: StoreDisplayGroupPlanogramApply = {
    id: maxId + 1,
    source: apply.source || 'benchmark',
    applyNo: generateNextApplyNo(),
    planogramCode: apply.planogramCode || '',
    planogramImageUrl: apply.planogramImageUrl || 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
    storeCode: apply.storeCode || '',
    storeName: apply.storeName || '',
    storeGroupCode: apply.storeGroupCode || '',
    storeGroupName: apply.storeGroupName || '',
    displayGroupCode: apply.displayGroupCode || '',
    displayGroupName: apply.displayGroupName || '',
    teamType: apply.teamType || TeamType.COMMERCIAL,
    applyStatus: ApplyStatus.PENDING,
    applyPerson: apply.applyPerson || 'current_user',
    applyPersonName: apply.applyPersonName || '当前用户',
    applyTime: now,
    applyReason: apply.applyReason || '',
    auditPerson: null,
    auditPersonName: null,
    auditTime: null,
    auditRemark: null,
    expectedEndDate: apply.expectedEndDate || null,
    actualEndDate: null,
    creatorAccount: apply.creatorAccount || 'current_user',
    creatorName: apply.creatorName || '当前用户',
    gmtCreate: now,
    modifierAccount: apply.modifierAccount || 'current_user',
    modifierName: apply.modifierName || '当前用户',
    gmtModified: now,
    deleted: 0
  };
  
  mockStoreDisplayGroupPlanogramApplies.push(newApply);
  return newApply;
};

/**
 * Simulate updating an apply
 * @param id Apply ID
 * @param updates Update data
 * @returns Updated apply or null if not found
 */
export const updateMockApply = (id: number, updates: Partial<StoreDisplayGroupPlanogramApply>): StoreDisplayGroupPlanogramApply | null => {
  const index = mockStoreDisplayGroupPlanogramApplies.findIndex(apply => apply.id === id);
  if (index === -1) return null;
  
  const now = new Date().toISOString().replace('T', ' ').substring(0, 19);
  mockStoreDisplayGroupPlanogramApplies[index] = {
    ...mockStoreDisplayGroupPlanogramApplies[index],
    ...updates,
    modifierAccount: 'current_user',
    modifierName: '当前用户',
    gmtModified: now
  };
  
  return mockStoreDisplayGroupPlanogramApplies[index];
};

/**
 * Simulate deleting an apply (soft delete)
 * @param id Apply ID
 * @returns True if deleted, false if not found
 */
export const deleteMockApply = (id: number): boolean => {
  const index = mockStoreDisplayGroupPlanogramApplies.findIndex(apply => apply.id === id);
  if (index === -1) return false;
  
  const now = new Date().toISOString().replace('T', ' ').substring(0, 19);
  mockStoreDisplayGroupPlanogramApplies[index] = {
    ...mockStoreDisplayGroupPlanogramApplies[index],
    deleted: 1,
    modifierAccount: 'current_user',
    modifierName: '当前用户',
    gmtModified: now
  };
  
  return true;
};